export { default, default as Divider } from './Divider'
export { default as dividerTheme } from './themes/Divider.theme'
export * as DividerStyles from './styles/Divider.style'

export type { DividerProps } from './Divider.types'
export type { AppearanceKeys, DividerTheme } from './themes/Divider.theme.types'
export type { StyledDividerProps } from './styles/Divider.style.types'
